import PropTypes from 'prop-types'
import { commonPageProps, storeProps } from '@proptypes'
import PageLayout from '#src/page/components/layout'
import Translation from '#src/common/components/translation'
import { findAllClickAndCollectStores } from './api'
import { Star } from '@pretamanger/component-library'
import ShopFinderContainer from '../components/shop-finder-container'
import { getGeocodeByLocale } from '#src/store-finder/components/shop-finder-container/api'
import { getMarketFromCtx } from '#lib/get-market'
import { getLaunchDarklyFlag } from '#api/flags'
import {
  anonymousIdHeader,
  myAccountV2Flag,
  strategicalShopFinderFlag
} from '#constants'
import OrderAheadClosedMessage from '#src/store-finder/components/order-ahead-closed-message'
import ShopFinder from '#src/shop-finder'
import { resultFilterTypes } from '#src/shop-finder/components/shop-finder-results-filter'
import { parseCookies } from 'nookies'
import { getShopFinderRegionsFromMarket } from '#src/shop-finder/util/ui'
import NotificationBanner from '#src/common/components/NotificationBanner'
import { removeUndefinedProperties } from '#src/common/lib/object'
import { getTransactionalPageProps } from '#src/common/init/get-common-props'
import { useAppSelector } from '#src/state/redux-hooks'
import { rewardsSelector } from '../../state/rewards-state-slice'

export const getServerSideProps = async ctx => {
  const { locale, gtmPageProps } = ctx
  const cookies = parseCookies(ctx)
  const user = cookies[anonymousIdHeader]
  const market = getMarketFromCtx(ctx)
  const [showStrategicalShopFinder, myAccountV2, commonProps, stores] =
    await Promise.all([
      getLaunchDarklyFlag(strategicalShopFinderFlag, user, market?.id),
      getLaunchDarklyFlag(myAccountV2Flag, user, market?.id),
      getTransactionalPageProps(ctx, '/shop-finder'),
      findAllClickAndCollectStores(ctx)
    ])
  const { fitBounds, center } = getGeocodeByLocale(locale)
  const shopFinderLocaleRegions = getShopFinderRegionsFromMarket(market, locale)
  return {
    props: removeUndefinedProperties({
      ...commonProps,
      defaultCenter: center,
      defaultFitBounds: fitBounds,
      stores,
      showStrategicalShopFinder,
      myAccountV2,
      shopFinderLocaleRegions,
      gtmPageProps,
      user
    })
  }
}

const StoreFinderPage = ({
  defaultCenter,
  defaultFitBounds,
  settings,
  stores,
  showStrategicalShopFinder,
  myAccountV2,
  shopFinderLocaleRegions
}) => {
  const { rewardsSummary = {} } = useAppSelector(rewardsSelector)
  if (showStrategicalShopFinder) {
    return (
      <PageLayout settings={settings}>
        <ShopFinder
          defaultCenter={defaultCenter}
          defaultFitBounds={defaultFitBounds}
          defaultFilters={[resultFilterTypes.orderAhead]}
          googleMapsJavaScriptApiKey={settings.googleMapsJavaScriptApiKey}
          displayClickAndCollect
          displayClickAndCollectShopsOnly
          showFilterMenu={false}
          localeRegions={shopFinderLocaleRegions}
          showPOI
        />
      </PageLayout>
    )
  }

  let banner = null
  if (myAccountV2) {
    if (rewardsSummary.noOfRewards) {
      banner = (
        <NotificationBanner
          variant='gold'
          colorVariant='white'
          iconVariant='loyaltyIcon'
          icon={<Star colour='white' />}
          layout='center'
        >
          <Translation id='storefinder.loyalty.notification.banner' />
        </NotificationBanner>
      )
    }
  }

  return (
    <>
      {banner}
      <PageLayout className='my-8' settings={settings}>
        <>
          {stores.length > 0 ? (
            <ShopFinderContainer
              defaultCenter={defaultCenter}
              defaultFitBounds={defaultFitBounds}
              defaultShops={stores}
              googleMapsJavaScriptApiKey={settings.googleMapsJavaScriptApiKey}
            />
          ) : (
            <OrderAheadClosedMessage />
          )}
        </>
      </PageLayout>
    </>
  )
}

StoreFinderPage.propTypes = {
  ...commonPageProps,
  stores: PropTypes.arrayOf(storeProps).isRequired
}

export default StoreFinderPage
